import sweetFactoryStoreIcon from '@rewardopl/assets/logos/sweetfactorystore.svg';

import { Wrapper } from './header.styles';

import { VENDOR_BUSINESS_NAME } from '../constants';

export default function Header() {
  return (
    <Wrapper>
      <img alt={VENDOR_BUSINESS_NAME} height={170} src={sweetFactoryStoreIcon} width={170} />
    </Wrapper>
  );
}
